import { Modal } from 'antd';
import { t } from 'ttag';
import { CustomButton } from '@/shared/ui/components';
import type { ConfirmCancelProcessModalProps } from './newStudy.types';
import './style.scss';

const ConfirmCancelProcessModal = ({
  isOpen,
  onClickYesButton,
  onClickNoButton,
}: ConfirmCancelProcessModalProps) => (
  <Modal
    open={isOpen}
    closable={false}
    footer={null}
    centered
    className="custom-modal"
    title={t`Cancel create new study`}
    classNames={{ header: 'custom-modal-header' }}
  >
    <div>
      <div className="custom-modal-content">{t`Are you sure you want to cancel this process?`}</div>
    </div>

    <div className="footer">
      <CustomButton
        styles={{ minWidth: 80 }}
        id="yes-button"
        type="outline"
        size="small"
        onClick={onClickYesButton}
      >
        {t`Yes`}
      </CustomButton>
      <CustomButton styles={{ minWidth: 80 }} id="no-button" size="small" onClick={onClickNoButton}>
        {t`No`}
      </CustomButton>
    </div>
  </Modal>
);

export default ConfirmCancelProcessModal;
